import React from "react"

import styled, { css } from "styled-components"
import algoliasearch from "algoliasearch/lite"

import {
  InstantSearch,
  Hits,
  Pagination,
  Configure,
  connectStateResults,
} from "react-instantsearch-dom"

import ListCardSearch from "./list-card-search"

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
)

const size = {
  tablet: 950,
  mobile: 600,
}

const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Container = styled.div`
  min-height: 1000px;
  max-width: 1248px;
  margin: 0 auto;
  padding: 48px 36px 88px;
  overflow: hidden;
  ${below.mobile`
     padding: 48px 24px;
    `}

  h1 {
    font-family: "Playfair Display";
    font-size: 56px;
    line-height: 72px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 16px;
  }

  .ais-ScrollTo h1 {
    margin: 0 0 48px;
  }

  .ais-Hits-item {
    transition: 0.3s ease-in-out;

    :hover {
      text-decoration: none;
      transform: translateY(-8px);
      box-shadow: 0px 12px 32px rgba(51, 51, 51, 0.1);
    }
  }
  .ais-Pagination {
    margin-top: 32px;
    ${above.mobile`
    
    margin-top:88px;`}
  }
  .ais-Pagination-list {
    display: flex;
    justify-content: center;
  }

  .ais-Pagination-item {
    padding-left: 0px;
    a,
    span {
      color: var(--grey);
      font-weight: 600;
      font-size: 14px;
      padding-bottom: 2px;
      width: 24px;
      height: 24px;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: center;
      justify-content: center;
      margin: 0px 4px;
      transition: all 0.3s ease-in-out 0s;
    }
    &:before {
      position: unset;
      top: unset;
      transform: unset;
      left: unset;
      content: unset;
      background-color: unset;
      width: unset;
      height: unset;
      border-radius: unset;
    }
  }

  .ais-Pagination-item a.ais-Pagination-link {
    &:hover {
      text-decoration: none;
      border-bottom: 1px solid var(--grey);
    }
  }

  .ais-Pagination-link--selected {
    color: black !important;
    border-bottom: 1px solid #000000;
    pointer-events: none;
  }

  .ais-Pagination-item--disabled span {
    border-radius: 50%;
    border: 0.4375px solid #e2e8f0;
    color: #e2e8f0;
  }

  .ais-Pagination-item.ais-Pagination-item--nextPage a,
  .ais-Pagination-item.ais-Pagination-item--previousPage a {
    border-radius: 50%;

    background: var(--grey);
    color: white;

    border: 0.4375px solid var(--grey);
  }
`

const HitsContainer = styled.div`
  .ais-Hits-list {
    display: grid;
    grid-template-columns: 1fr;

    row-gap: 32px;
    ${above.mobile`
        grid-template-columns: 1fr 1fr;
        column-gap: 40px;
  row-gap: 40px;
    `}

    ${above.tablet`
            grid-template-columns: 1fr 1fr 1fr;
            column-gap: 44px;
  row-gap: 80px;
    `}
  }

  .ais-Hits-item {
    padding-left: 0px;
    &:before {
      position: unset;
      top: unset;
      transform: unset;
      left: unset;
      content: unset;
      background-color: unset;
      width: unset;
      height: unset;
      border-radius: unset;
    }
  }
`

// Custom State Results Styled Components

const SearchResultsHeader = styled.div`
  .no-results-homebuyers {
    font-weight: 600;
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 40px;
    color: var(--alt-black);
  }
  h1 {
    font-family: "Playfair Display";
    font-size: 56px;
    line-height: 72px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 64px;
  }

  p {
    color: var(--alt-black);

    font-size: 18px;
    line-height: 32px;
    text-align: left;
    ${above.mobile`
    text-align:center;
    `}
  }
  h2 {
    color: var(--grey);
    font-size: 18px;
    line-height: 28px;
    font-weight: 400;
    ${above.mobile`
  font-size:22px;
  line-height:28px;
  `}
  }
  h3 {
    color: var(--alt-black);
    font-weight: 400;
    font-size: 36px;
    line-height: 44px;
    margin-bottom: 8px;
    ${above.mobile`
    text-align:center;
    `}
  }

  .no-results-spelling {
    line-height: 28px;
    margin-bottom: 96px;
  }
`

const SearchResultsContainer = styled.div`
  margin-bottom: 40px;
  .ais-Pagination {
    margin-top: 0;
  }

  .pagination-mobile {
    margin-bottom: 8px;
    ${above.mobile`
    display:none;
    `}
  }

  .pagination-tablet {
    margin-bottom: 0;
  }

  .ais-Pagination-list {
    justify-content: flex-end;
  }
  h2 {
    font-weight: 600;
    margin-bottom: 0;
  }
  p {
    color: var(--grey);
    font-size: 14px;
    line-height: 17.6px;
    margin-bottom: 0;

    ${above.mobile`
    font-size:18px;
    line-height:28px;
    `}
  }
`

const SearchResultsContainerMobile = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${above.mobile`
  display:none;
  `}
`

const SearchResultsContainerTablet = styled.div`
  display: flex;
  justify-content: space-between;
  ${below.mobile`
display:none;
`}
`

const SearchResultsContainerRight = styled.div`
  display: flex;
  align-items: center;
`

const NoResultsSuggestionsContainer = styled.div`
  .ais-Hits-item {
    transition: 0.3s ease-in-out;

    :hover {
      text-decoration: none;
      transform: translateY(-8px);
      box-shadow: 0px 3px 32px rgba(0, 0, 0, 0.1);
    }
    padding-left: 0px;
    &:before {
      position: unset;
      top: unset;
      transform: unset;
      left: unset;
      content: unset;
      background-color: unset;
      width: unset;
      height: unset;
      border-radius: unset;
    }
  }
  .ais-Hits-list {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 32px;
    ${above.mobile`
        grid-template-columns: 1fr 1fr;

    `}

    ${above.tablet`
            grid-template-columns: 1fr 1fr 1fr;

    `}
  }
`

const StateResults = ({ searchState, searchResults }) => {
  const noResults = searchResults && searchResults.nbHits === 0
  return (
    <SearchResultsHeader>
      {noResults && (
        <>
          <h3 className="sans">No results for ‘{searchResults.query}’.</h3>
          <p className="no-results-spelling">
            Please check your spelling or try another search term.
          </p>
          <h2 className="no-results-homebuyers sans">
            Homebuyers are enjoying these other articles:
          </h2>
          <NoResultsSuggestionsContainer>
            <InstantSearch
              searchClient={searchClient}
              indexName="knowledge-center"
            >
              <Hits hitComponent={ListCardSearch} />
              <Configure hitsPerPage={12} />
            </InstantSearch>
          </NoResultsSuggestionsContainer>
        </>
      )}
      {!searchState.query ? (
        <>
          <h1>Search for Articles</h1>
        </>
      ) : (
        !noResults && (
          <SearchResultsContainer>
            <SearchResultsContainerMobile>
              <h2 className="sans">Knowledge Center Articles</h2>
              <p>{searchResults?.nbHits} results</p>
            </SearchResultsContainerMobile>
            <SearchResultsContainerTablet>
              <h2 className="sans">Knowledge Center Articles</h2>
              <SearchResultsContainerRight>
                <p>{searchResults?.nbHits} results</p>
              </SearchResultsContainerRight>
            </SearchResultsContainerTablet>
          </SearchResultsContainer>
        )
      )}
    </SearchResultsHeader>
  )
}

const CustomStateResults = connectStateResults(StateResults)

const StateResultsPagination = ({ searchState, searchResults }) => {
  const noResults = searchResults && searchResults.nbHits === 0
  return (
    <SearchResultsHeader>
      {noResults ? null : <Pagination showFirst={false} padding={2} />}
    </SearchResultsHeader>
  )
}
const CustomStateResultsPagination = connectStateResults(StateResultsPagination)

const AlgoliaResults = props => {
  return (
    <Container>
      <CustomStateResults />
      <HitsContainer>
        <Hits
          hitComponent={hit => (
            <ListCardSearch bankerData={props.bankerData} hit={hit} />
          )}
        />
      </HitsContainer>
      <CustomStateResultsPagination />
    </Container>
  )
}
export default AlgoliaResults
